module.exports = __webpack_public_path__ + "img/checked-box-all.bc3a879b.svg";